import Record from './base'
// import phoneFns from 'phone-fns'

// const phoneLib = phoneFns()

export class User extends Record {
  get formattedPhone() {
    return ''
    // return phoneLib.format('(NNN) NNN.NNNN', this.phone.replace('+1', ''))
  }
  set formattedPhone(phone) {
    this.formattedPhone = phone
  }
}
